package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ru.chm.gradereport.model.AttendanceStatus

@Composable
internal fun AttendanceCell(
    status: AttendanceStatus?,
    editable: Boolean,
    onClick: () -> Unit,
) {
    val color = statusColor(status)
    Box(
        modifier = Modifier
            .requiredWidth(ColMark)
            .padding(6.dp)
            .height(48.dp)
            .clip(RoundedCornerShape(10.dp))
            .background(color.copy(alpha = 0.22f), RoundedCornerShape(10.dp))
            .border(1.dp, color.copy(alpha = 0.45f), RoundedCornerShape(10.dp))
            .clickable(enabled = editable, onClick = onClick),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            statusLabel(status),
            color = color,
            fontWeight = FontWeight.Bold,
            fontSize = 22.sp,
        )
    }
}
